const e = {
  "cdr-image": "cdr-image_15-5-1"
};
export {
  e as default
};
